import React from 'react';
import scaleSize from '../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(20)}
    height={scaleSize(24)}
    viewBox="0 0 20 24"
  >
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M1.521.15L19.52 11.147a1 1 0 0 1 0 1.706L1.52 23.85A1 1 0 0 1 0 22.997V1.003A1 1 0 0 1 1.521.15z"
    />
  </svg>
);
